import { createStore } from '@servicetitan/financing-utils-shared';
import { useState } from 'react';

interface PrequalsInitialData {
    operatingStates?: string[] | null;
    defaultLoanAmount?: number | null;
    defaultRepresentativeEmail?: string | null;
}

function usePrequals(initialData?: PrequalsInitialData | null) {
    const [isAmountConfirmed, setIsAmountConfirmed] = useState(false);
    const [prequalMaxAmount, setPrequalMaxAmount] = useState(0);
    const [operatingStates] = useState<string[] | null | undefined>(initialData?.operatingStates);
    const [defaultLoanAmount] = useState<number | null | undefined>(initialData?.defaultLoanAmount);
    const [defaultRepresentativeEmail] = useState<string | null | undefined>(
        initialData?.defaultRepresentativeEmail,
    );

    return {
        isAmountConfirmed,
        setIsAmountConfirmed,
        prequalMaxAmount,
        setPrequalMaxAmount,
        operatingStates,
        defaultLoanAmount,
        defaultRepresentativeEmail,
    };
}

export const PrequalsStore = createStore(usePrequals);
